import "core-js/modules/es6.string.starts-with";

/**
 * Returns true if the provided key is a CSS variable
 */
function isCSSVariable(key) {
  return key.startsWith("--");
}

export { isCSSVariable };